import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NotificationAddIcon(props: IconProps) {
    return <Icon {...props} iconKey={"notification_add"}/>
}
